const Twitter = ({ width = '24px', height = '24px' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height}>
      <path
        d="M20 7.538a6.553 6.553 0 01-1.885.517 3.297 3.297 0 001.443-1.815 6.616 6.616 0 01-2.086.797 3.283 3.283 0 00-5.592 2.993A9.318 9.318 0 015.115 6.6a3.259 3.259 0 00-.445 1.65c0 1.14.58 2.144 1.46 2.732a3.282 3.282 0 01-1.486-.412v.041a3.286 3.286 0 002.632 3.22 3.324 3.324 0 01-.864.115 3.15 3.15 0 01-.618-.061 3.284 3.284 0 003.065 2.28 6.584 6.584 0 01-4.076 1.403c-.265 0-.526-.016-.783-.045A9.276 9.276 0 009.031 19c6.038 0 9.338-5.002 9.338-9.34l-.01-.426A6.555 6.555 0 0020 7.538z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export default Twitter;
